import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InputFormatDate } from "./input-format-date.pipe";

@NgModule({
  declarations: [InputFormatDate],
  imports: [CommonModule],
  exports: [InputFormatDate],
})

export class CustomPipesModule {}
